export enum TireFunction {
  NULL = 'NULL',

  DIRECTIONAL = 'DIRECTIONAL',

  TRACTION = 'TRACTION',

  ROLLING = 'ROLLING',
}
